import React from 'react';
import { Button } from "devextreme-react";

interface DrawerFooterProps {
    handleSubmit: () => void;
    onCancelClick: (cancel: boolean) => void;
    disableButton?: boolean
  }

const DrawerFooter: React.FC<DrawerFooterProps> = ({handleSubmit, onCancelClick, disableButton}) => {
  return (
    <div className="dx-drawer-footer-item">
        <Button
            className="dx-drawer-cancel-button"
            onClick={() => onCancelClick(false)}
            text="Cancel"
            type="default"
            stylingMode="outlined"
        />
        <Button
            className={disableButton ? "dx-drawer-disable-button" : "dx-drawer-submit-button"}
            onClick={handleSubmit}
            text={disableButton ? "Remove" : "Save"}
            type={disableButton ? "danger" : "default"}
            stylingMode="contained"
        />
    </div>
  );
}

export default DrawerFooter;

